import { useMemo } from 'react'
import { useLead } from '@/shared/api/leads'
import { rowAsLead } from '@/shared/api/leadLists'
import type { Lead, LeadRow } from '@/shared/types'

// List rows carry only what the list views read (LeadRow). This hook fetches
// the full lead for an open card and lays the row over it: the card-only
// fields come from the detail, the row's own fields keep coming from the list
// so a Focus poll or an optimistic update isn't overwritten by a staler detail
// snapshot. Until the detail arrives the card renders the row (rowAsLead).
export function useLeadDetail(lead: LeadRow): Lead
export function useLeadDetail(lead: LeadRow | null): Lead | null
export function useLeadDetail(lead: LeadRow | null): Lead | null {
  const { data: detail } = useLead(lead?.id ?? null)
  return useMemo(() => {
    if (!lead) return null
    if (!detail || detail.id !== lead.id) return rowAsLead(lead)
    return { ...detail, ...lead }
  }, [lead, detail])
}
